import { create } from 'zustand'

import apiHandler from 'components/Defaults/ApiHandler'
import axios from 'axios'

export const getUserLibrary = (callback, errorCallback) => {
    const config = {
        url: '/api/document/get_library'
    }
    apiHandler("Getting library", config, async config => {
        const response = await axios.request(config);
        callback && callback(response.data)
    }, errorCallback)
}

export const addToLibrary = (id, callback, errorCallback) => {
  const config = {
      url: `/api/document/${id}/add_to_library`
  }
  apiHandler("Adding to library", config, async config => {
      const response = await axios.request(config);
      callback && callback(response.data)
  }, errorCallback)
}

export const deleteFromLibrary = (id, callback, errorCallback) => {
  const config = {
      url: `/api/document/${id}/remove_from_library`
  }
  apiHandler("Removing from library", config, async config => {
      const response = await axios.request(config);
      callback && callback(response.data)
  }, errorCallback)
}

export const useLibraryStore = create((set, get) => ({
  
  library: [],
  loading: false,
  
  fetchLibrary: () => {
    set(() => ({ loading: true }))
    
    if (get().library > 0) {
      set(() => ({ loading: false }))
      return
    }

    getUserLibrary(
      (data) => {
        set(() => ({ library: data.library }))
        set(() => ({ loading: false }))
      }, (error) => {
        console.error('Error fetching library:', error);
        set(() => ({ loading: false }))
      }
    );
  },
  addToLibrary: (id) => {
    set(() => ({ loading: true }))
    addToLibrary(id, () => {
      const updatedLibrary = get().library.map((doc) => {
        if (doc.id === id) {
          return { ...doc, book_in_library: true }
        }
        return doc
      })
      set(() => ({ library: updatedLibrary }))
      set(() => ({ loading: false }))
    }, (error) => {
      console.error('Error adding to library:', error);
      set(() => ({ loading: false }))
    })
  },
  deleteFromLibrary: (id) => {
    set(() => ({ loading: true }))
    deleteFromLibrary(id, () => {
      const updatedLibrary = get().library.filter((doc) => doc.id !== id)
      set(() => ({ library: updatedLibrary }))
      set(() => ({ loading: false }))
    }, (error) => {
      console.error('Error deleting from library:', error);
      set(() => ({ loading: false }))
    })
  }
}))

